var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0133 28.3333C11.76 28.3333 11.5067 28.24 11.3067 28.04L4.62667 21.36C4.24 20.9733 4.24 20.3333 4.62667 19.9467C5.01334 19.56 5.65334 19.56 6.04 19.9467L12.72 26.6267C13.1067 27.0133 13.1067 27.6533 12.72 28.04C12.52 28.2267 12.2667 28.3333 12.0133 28.3333Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0133 28.3333C11.4667 28.3333 11.0133 27.88 11.0133 27.3333V4.66667C11.0133 4.12001 11.4667 3.66667 12.0133 3.66667C12.56 3.66667 13.0133 4.12001 13.0133 4.66667V27.3333C13.0133 27.88 12.56 28.3333 12.0133 28.3333Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.68 12.3467C26.4267 12.3467 26.1733 12.2533 25.9733 12.0533L19.2933 5.37333C18.9067 4.98667 18.9067 4.34666 19.2933 3.96C19.68 3.57333 20.32 3.57333 20.7067 3.96L27.3867 10.64C27.7733 11.0267 27.7733 11.6667 27.3867 12.0533C27.1867 12.2533 26.9333 12.3467 26.68 12.3467Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9867 28.3333C19.44 28.3333 18.9867 27.88 18.9867 27.3333V4.66667C18.9867 4.12001 19.44 3.66667 19.9867 3.66667C20.5333 3.66667 20.9867 4.12001 20.9867 4.66667V27.3333C20.9867 27.88 20.5467 28.3333 19.9867 28.3333Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwap);
export default __webpack_public_path__ + "static/media/arrow-swap.9a3a5beb.svg";
export { ForwardRef as ReactComponent };